
// eslint-disable-next-line import-x/named
import { PiniaPluginContext } from 'pinia';

import { AbortError, TranslatableError } from '@/errors';

function TranslatableErrorHandlerPiniaPlugin({ store }: PiniaPluginContext) {
  store.$onAction(({ name, onError }) => {
    onError(e => {
      if (AbortError.isAbortRelated(e)) throw e;
      throw e instanceof TranslatableError ? e : new TranslatableError(`errors.${store.$id}.${name}`, e);
    });
  });
}

export default TranslatableErrorHandlerPiniaPlugin;
